import type { DeploySceneConfig } from '../../platform/scenes/types';

/** 训练集群直建「资源配置」步模块（复用 MI baseInfo/runtimeConfig，不含网关/服务等模型实例模块）。 */
export const TC_DIRECT_MERGED_MODULES = ['baseInfo', 'runtimeConfig', 'nodeGroups', 'envVars', 'initCommand'] as const;

export type TcDirectMergedModuleKey = (typeof TC_DIRECT_MERGED_MODULES)[number];

/**
 * 训练集群 SKU / 下单模块顺序。
 * 对齐直建可见勾选块相对序：nodeGroups → storage（直建 afterNodeGroupsExtra）→ envVars → initCommand；
 * runtimeConfig 下单不展示，故不列入。
 */
export const TC_SKU_MODULE_KEYS = ['nodeGroups', 'storage', 'envVars', 'initCommand'] as const;

/** 训练集群 SKU 与下单模块列表。 */
export const TC_SKU_MODULE_LIST: string[] = [...TC_SKU_MODULE_KEYS];

/** 训练集群 SKU 配置预览模块顺序（与编辑勾选块 / 直建确认步对齐）。 */
export const TC_SKU_PREVIEW_MODULE_ORDER = [...TC_SKU_MODULE_KEYS] as const;

/** 训练集群下单模块标题 i18n key。 */
export const TC_ORDER_MODULE_TITLE: Record<string, string> = {
  envVars: 'data-center:maas.section.envVars',
  nodeGroups: 'data-center:maas.step.groups',
  storage: 'common:shared.storage.volume',
  initCommand: 'data-center:maas.init.command.and.args',
};

const TC_SKU_MODULE_KEY_SET = new Set<string>(TC_SKU_MODULE_KEYS);

/** 仅保留训练集群 SKU 场景模块。 */
export function filterTcSkuModules<T extends { key: string }>(modules: readonly T[]): T[] {
  return modules.filter((item) => TC_SKU_MODULE_KEY_SET.has(item.key));
}

/** 训练集群插件场景定义。 */
export const TC_SCENES: Record<'sku' | 'order', DeploySceneConfig> = {
  sku: { modules: [...TC_SKU_MODULE_KEYS], linkage: false },
  order: { modules: [...TC_SKU_MODULE_KEYS], linkage: false },
};

/** 获取训练集群场景配置。 */
export function resolveTcSceneConfig(scene?: 'sku' | 'order'): DeploySceneConfig {
  return TC_SCENES[scene ?? 'sku'];
}
